/***
 *
 *   PROJECT MARK
 *   Small square-ish identity avatar for a project or an organisation.
 *   Ported from ui-reference/src/components/layouts/project-mark.tsx.
 *
 *   The reference's `projectInitials` is the same algorithm as
 *   `initialsFromName` in components/avatar/userAvatar.js, so this reuses that
 *   rather than carrying a second copy.
 *
 *   Logo paths come off the API without a scheme in this app (`file_path` is
 *   bare `s3.../x.png`), which the reference's `publicFileUrl` has no
 *   equivalent of — `logoUrl` below is the local stand-in.
 *
 *   PROPS
 *   name: display name, used for the initials fallback
 *   filePath: raw `file_path` off the API (optional)
 *   src: fully-qualified image url, if the caller already has one (optional)
 *   className / fallbackClassName: injected classes
 *
 **********/

import { UserAvatar } from 'components/lib';

export function logoUrl(filePath) {
    if (!filePath) return undefined;
    return filePath.startsWith('http') ? filePath : `https://${filePath}`;
}

export function ProjectMark(props) {
    return (
        <UserAvatar
            size="sm"
            name={props.name}
            src={props.src || logoUrl(props.filePath)}
            className={props.className}
            // The reference drops the fallback to 10px here so two initials fit
            // the 8x8 mark without crowding.
            fallbackClassName={`text-[10px] font-semibold ${props.fallbackClassName || ''}`}
            bordered
        />
    );
}
